<template>
  <main class="home page content" :class="!loading && (latestEpisodes && latestExtras) ? '' : 'loading'">
    <hero :episode="featuredEpisode"></hero>
    <latest-episodes :episodes="latestEpisodes"></latest-episodes>
    <call-to-action></call-to-action>
    <latest-extras :extras="latestExtras"></latest-extras>
    <start-here></start-here>
    <testimonials></testimonials>
    <shop-module></shop-module>
  </main>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Hero from '@/components/home/Hero'
import LatestEpisodes from '@/components/home/LatestEpisodes'
import CallToAction from '@/components/home/CallToAction'
import LatestExtras from '@/components/home/LatestExtras'
import StartHere from '@/components/home/StartHere'
import Testimonials from '@/components/home/Testimonials'
import ShopModule from '@/components/common/ShopModule'

export default {
  name: 'home',
  components: {
    Hero,
    LatestEpisodes,
    CallToAction,
    LatestExtras,
    StartHere,
    Testimonials,
    ShopModule
  },
  data () {
    return {
      loading: true
    }
  },
  mounted () {
    let vm = this
    if (window.wpApiSettings && window.wpApiSettings.nonce && (vm.$route.query.preview === 'true')) {
      vm.$router.push({ name: 'Preview', query: { preview_id: vm.$route.query.p } })
    } else {
      vm.fetchEpisodes()
      vm.fetchExtras()
    }
  },
  methods: {
    fetchEpisodes () {
      let vm = this
      // GET /episodes => get_episodes() [theme-folder]/api/functions.php
      vm.$axios.get('/episodes')
      .then((response) => {
        vm.setEpisodes(response.data)
        vm.loading = false
      })
      .catch((err) => {
        console.log(err.response)
        vm.loading = false
      })
    },
    fetchExtras () {
      let vm = this
      // GET /extras => get_extras() [theme-folder]/api/functions.php
      vm.$axios.get('/extras')
      .then((response) => {
        vm.setExtras(response.data)
        vm.loading = false
      })
      .catch((err) => {
        console.log(err.response)
        vm.loading = false
      })
    },
    ...mapActions([
      'setEpisodes',
      'setExtras'
    ])
  },
  computed: {
    ...mapGetters([
      'featuredEpisode',
      'latestEpisodes',
      'latestExtras'
    ])
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>



// WEBPACK FOOTER //
// Home.vue?ee223356